<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page page-404">
                <div class="container">
                    <div class="page-title">Страница не найдена</div>
                    <div class="page-404-content">Перейти на <router-link :to="{name: 'Index'}" title="На главную">главную</router-link></div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';

    export default {
        name: "Error404",

        components: {
            Header, Footer
        }
    }
</script>